export default __webpack_public_path__ + "static/media/excitedGreyBackground.edf3bb6a.svg";